import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import "./dropDown.css";

const ProjectFilterDropdown = ({ value, onChange, projects = [] }) => {
  const [isOpen, setIsOpen] = useState(false);

  const options = [
    { value: "", label: "All Projects" },
    ...projects.map((p) => ({ value: p._id, label: p.project_name })),
  ];

  const selectedOption = options.find((opt) => opt.value === value);

  const handleSelect = (optionValue) => {
    onChange({ target: { value: optionValue } });
    setIsOpen(false);
  };

  return (
    <div className="vrhistory-dropdown-wrapper">
      <button
        className="vrhistory-dropdown-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="vrhistory-dropdown-label">
          {selectedOption?.label || "All Projects"}
        </span>
        <ChevronDown
          size={18}
          className={`vrhistory-dropdown-chevron ${isOpen ? "open" : ""}`}
        />
      </button>

      {isOpen && (
        <div className="vrhistory-dropdown-menu">
          {options.map((option) => (
            <button
              key={option.value}
              className={`vrhistory-dropdown-option ${
                value === option.value ? "active" : ""
              }`}
              onClick={() => handleSelect(option.value)}
            >
              <span className="vrhistory-option-label">{option.label}</span>
              {value === option.value && (
                <span className="vrhistory-checkmark">✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectFilterDropdown;